import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CompanionConfigVersionList from './CompanionConfigVersionList';
import { initialCompanionConfigVersionState } from '../../reducers/initialState';
import {
  getCompanionConfigVersionManager,
  getUserProfileWidget,
  getCurrentTimezone,
  getUserOrgModelCategoryType
} from '../../selectors/index';
import {
  getCompanionConfigVersionsThunk,
  deleteCompanionConfigVersionThunk,
  setCurrentPage,
  resetCompanionConfigVersionStatus
} from '../../actions/companionConfigVersion';

const mapStateToProps = state => {
  return {
    companionConfigVersionManager: getCompanionConfigVersionManager(state) || {
      ...initialCompanionConfigVersionState.companionConfigVersionManager
    },
    userProfileWidgets: getUserProfileWidget(state),
    currentTimezone: getCurrentTimezone(state),
    userModelCategories: getUserOrgModelCategoryType(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getCompanionConfigVersions: (modelId, offset, limit) =>
        getCompanionConfigVersionsThunk(modelId, offset, limit, 'COMPANIONCONFIGVERSIONLIST'),
      deleteCompanionConfigVersion: (companionConfigVersion, widgetCode) =>
        deleteCompanionConfigVersionThunk(companionConfigVersion, widgetCode),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      resetCompanionConfigVersionStatus: () => resetCompanionConfigVersionStatus()
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CompanionConfigVersionList);
